import { Component, ViewChild, TemplateRef, Input, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-product-countries',
  templateUrl: './product-countries.component.html',
  styleUrls: ['./product-countries.component.scss']
})
export class ProductCountriesComponent implements OnInit {

  isProcessing: boolean = false;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }


  dropDownDataForAuthorizationCountry: any = [];
  selectedLocations: any = [];
  dropdownForLocations: any = [];
  locationsDropdown: any = [];
  oddAuthCountry: any = null;
  ngOnInit() {
    this.isProcessing = true;
    this.getCall();
    this.appService.getNonOrgCodeListsByGroupName("COUNTRY").subscribe((response: any) => {
      this.dropDownDataForAuthorizationCountry = response;
      this.selectBoxForAuthCountry();
      this.isProcessing = false;
    })

    this.appService.getAllLocations().subscribe((response) => {
      this.dropdownForLocations = response;
      this.selectBoxForLocations();
    })

  }

  @Input() productCountriesFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  refreshGridData() {
    this.getCall();
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/productMaster']);
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    ...this.singleSelectDropdownSetting,
    enableCheckAll: true,
    singleSelection: false,
    itemsShowLimit: 3,
    closeDropDownOnSelection: false,
  };

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        throw error;
      }
    })
    this.isProcessing = false;

  }

  htmlContent: any;
  selectedAuthorizationCountry: any = null;
  listOfAuthorizationCountryDropdown: any = [];
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForAuthCountry() {
    this.listOfAuthorizationCountryDropdown = this.dropDownDataForAuthorizationCountry?.map((country: any) => ({
      valueExp: country.codelistCode,
      displayExp: country.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  authorizationCountrysearchTxt: any;

  selectBoxForLocations() {
    this.locationsDropdown = [];
    this.locationsDropdown = this.dropdownForLocations?.map((location: any) => ({
      valueExp: location.locationId,
      displayExp: location.locationName
    }))
  }
  @ViewChild('locations') locations: MatSelect;
  isLocationsSelected = false;
  locationsSearchText: any;
  toggleAllSelection(value: any) {
    if (value == 'locations') {
      if (this.isLocationsSelected) this.locations.options.forEach((item: MatOption) => item.select());
      else this.locations.options.forEach((item: MatOption) => item.deselect());
    }

  }

  onLocationsSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isLocationsSelected = this.locationsDropdown.length == this.selectedLocations.length; })
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Product Country";
    this.productCountriesFieldData.productId = null;
    this.selectedAuthorizationCountry = null;
    this.selectedLocations = [];
    this.productCountriesFieldData.tradeName = '';
    this.productCountriesFieldData.manufactureHolder = '';
    this.productCountriesFieldData.authorizationNumber = '';
    this.productCountriesFieldData.birthDate = null;
    this.productCountriesFieldData.withdrawnDate = null;
    this.productCountriesFieldData.comments = '';
    setTimeout(() => { this.isLocationsSelected = this.locationsDropdown.length == this.selectedLocations.length; })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  description: any

  previousData: any;
  previousDataProductCountryId: any;
  qmsProductCountriesVwEditDetails: any = [];
  filteredAuthorizationCountryValue: any;
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update Product Country";
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = "Info";
    }

    this.previousDataProductCountryId = editRowData.PRODUCT_COUNTRY_ID;
    this.appService.getQmsProductCountriesVwDetailsByProductCountryId(editRowData.PRODUCT_COUNTRY_ID).subscribe((response: any) => {
      this.qmsProductCountriesVwEditDetails = response;
      this.productCountriesFieldData.productId = this.qmsProductCountriesVwEditDetails.productId;
      this.productCountriesFieldData.productCountryId = this.qmsProductCountriesVwEditDetails.productCountryId;
      this.productCountriesFieldData.tradeName = this.qmsProductCountriesVwEditDetails.tradeName;
      this.productCountriesFieldData.manufactureHolder = this.qmsProductCountriesVwEditDetails.manufactureHolder;
      this.productCountriesFieldData.authorizationNumber = this.qmsProductCountriesVwEditDetails.authorizationNumber;
      this.productCountriesFieldData.comments = this.qmsProductCountriesVwEditDetails.comments;
      this.productCountriesFieldData.listOfLocations = this.qmsProductCountriesVwEditDetails.listOfLocations;

      if (this.qmsProductCountriesVwEditDetails.birthDate) {
        let birthDateValue = new Date(this.qmsProductCountriesVwEditDetails.birthDate.split('T'));
        this.productCountriesFieldData.birthDate = birthDateValue;
      } else {
        this.productCountriesFieldData.birthDate = null;
      }

      if (this.qmsProductCountriesVwEditDetails.withdrawnDate) {
        let withdrawnDateValue = new Date(this.qmsProductCountriesVwEditDetails.withdrawnDate.split('T'));
        this.productCountriesFieldData.withdrawnDate = withdrawnDateValue;
      } else {
        this.productCountriesFieldData.withdrawnDate = null;
      }

      if (this.productCountriesFieldData.listOfLocations) {
        this.selectedLocations = this.productCountriesFieldData.listOfLocations.split(',').map(Number);
        setTimeout(() => {
          this.productCountriesFieldData.listOfLocations.split(',').length == this.dropdownForLocations.length && this.locations.options.forEach((item: MatOption) => item.select());
          this.isLocationsSelected = this.locationsDropdown.length == this.selectedLocations.length;
        })
      }

      if (this.qmsProductCountriesVwEditDetails.authorizationCountry) {
        const matchingAuthorizationCountry = this.dropDownDataForAuthorizationCountry?.find((item: any) => item.codelistCode == this.qmsProductCountriesVwEditDetails.authorizationCountry);
        if (!matchingAuthorizationCountry) {
          this.oddAuthCountry = this.qmsProductCountriesVwEditDetails.authorizationCountry;
          this.listOfAuthorizationCountryDropdown.push({
            valueExp: this.qmsProductCountriesVwEditDetails.authorizationCountry,
            displayExp: this.qmsProductCountriesVwEditDetails.authorizationCountry
          })
        }
        this.selectedAuthorizationCountry = this.qmsProductCountriesVwEditDetails.authorizationCountry
      }
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }


  manufactureHolderValue: any;
  tradeNameValue: any;

  authorizationCountryValueRequiredMsg: any;
  manufactureHolderValueRequiredMsg: any;
  tradeNameValueRequiredMsg: any;
  fieldValidation() {
    this.manufactureHolderValue = document.getElementById('manufactureHolder') as HTMLInputElement;
    this.tradeNameValue = document.getElementById('tradeName') as HTMLInputElement;

    this.authorizationCountryValueRequiredMsg = document.getElementById('authorizationCountry-required-msg') as HTMLInputElement;
    this.manufactureHolderValueRequiredMsg = document.getElementById('manufactureHolder-required-msg') as HTMLInputElement;
    this.tradeNameValueRequiredMsg = document.getElementById('tradeName-required-msg') as HTMLInputElement;

    if (this.selectedAuthorizationCountry) {
      this.authorizationCountryValueRequiredMsg.style.display = 'none';
    } else {
      this.authorizationCountryValueRequiredMsg.style.display = 'block';
    }

    if (this.productCountriesFieldData.manufactureHolder == "") {
      this.manufactureHolderValue.style.border = '1px solid red';
      this.manufactureHolderValueRequiredMsg.style.display = 'block';
    } else {
      this.manufactureHolderValue.style.border = 'none';
      this.manufactureHolderValueRequiredMsg.style.display = 'none';
    }

    if (this.productCountriesFieldData.tradeName == "") {
      this.tradeNameValue.style.border = '1px solid red';
      this.tradeNameValueRequiredMsg.style.display = 'block';
    } else {
      this.tradeNameValue.style.border = 'none';
      this.tradeNameValueRequiredMsg.style.display = 'none';
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  addAndEditFunction(productCountriesFieldData: any) {
    this.isProcessing = true;
    if (!this.selectedAuthorizationCountry || productCountriesFieldData.manufactureHolder == "" || productCountriesFieldData.tradeName == "" || this.selectedLocations.length < 1) {
      this.fieldValidation();
      alert("Please enter all mandatory fields !")
      this.isProcessing = false;
    } else if (this.operationFlag == 'ADD') {
      productCountriesFieldData.productId = this.message.productIdFromProductMaster;
      productCountriesFieldData.tradeName = this.productCountriesFieldData.tradeName;
      productCountriesFieldData.manufactureHolder = this.productCountriesFieldData.manufactureHolder;
      productCountriesFieldData.authorizationNumber = this.productCountriesFieldData.authorizationNumber;
      productCountriesFieldData.comments = this.productCountriesFieldData.comments;
      productCountriesFieldData.listOfLocations = this.selectedLocations?.map(String).join(',');

      if (this.selectedAuthorizationCountry) {
        productCountriesFieldData.authorizationCountry = this.selectedAuthorizationCountry;
      } else {
        productCountriesFieldData.authorizationCountry = null;
      }

      if (this.productCountriesFieldData.birthDate) {
        productCountriesFieldData.birthDate = new Date(this.productCountriesFieldData.birthDate);
        productCountriesFieldData.birthDate = this.appService.dateZoneConvertion(productCountriesFieldData.birthDate);
      } else {
        productCountriesFieldData.birthDate = null;
      }

      if (this.productCountriesFieldData.withdrawnDate) {
        productCountriesFieldData.withdrawnDate = new Date(this.productCountriesFieldData.withdrawnDate);
        productCountriesFieldData.withdrawnDate = this.appService.dateZoneConvertion(productCountriesFieldData.withdrawnDate);
      } else {
        productCountriesFieldData.withdrawnDate = null;
      }

      this.appService.createQmsProductCountries(this.productCountriesFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.isProcessing = false;
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      delete productCountriesFieldData.createdOn;
      delete productCountriesFieldData.updatedOn;

      productCountriesFieldData.productId = this.previousData.PRODUCT_ID;
      productCountriesFieldData.productCountryId = this.previousData.PRODUCT_COUNTRY_ID;
      productCountriesFieldData.tradeName = this.productCountriesFieldData.tradeName;
      productCountriesFieldData.manufactureHolder = this.productCountriesFieldData.manufactureHolder;
      productCountriesFieldData.authorizationNumber = this.productCountriesFieldData.authorizationNumber;
      productCountriesFieldData.comments = this.productCountriesFieldData.comments;
      productCountriesFieldData.listOfLocations = this.selectedLocations?.map(String).join(',');

      if (this.selectedAuthorizationCountry) {
        productCountriesFieldData.authorizationCountry = this.selectedAuthorizationCountry;
      } else {
        productCountriesFieldData.authorizationCountry = null;
      }

      if (this.productCountriesFieldData.birthDate) {
        productCountriesFieldData.birthDate = new Date(this.productCountriesFieldData.birthDate);
        productCountriesFieldData.birthDate = this.appService.dateZoneConvertion(productCountriesFieldData.birthDate);
      } else {
        productCountriesFieldData.birthDate = null;
      }

      if (this.productCountriesFieldData.withdrawnDate) {
        productCountriesFieldData.withdrawnDate = new Date(this.productCountriesFieldData.withdrawnDate);
        productCountriesFieldData.withdrawnDate = this.appService.dateZoneConvertion(productCountriesFieldData.withdrawnDate);
      } else {
        productCountriesFieldData.withdrawnDate = null;
      }

      this.appService.updateQmsProductCountries(this.productCountriesFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();

            this.isProcessing = false;
            this.ngOnInit();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteProductCountriesId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Product Country";
    this.deleteProductCountriesId = deleteRowData.PRODUCT_COUNTRY_ID;
    if (this.productCountriesFieldData.deleteReason != undefined) {
      this.productCountriesFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {
        productCountryId: this.deleteProductCountriesId,
        deleteReason: this.productCountriesFieldData.deleteReason,
      }
      this.appService.deleteQmsProductCountries(data).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getCall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "PRODUCT_COUNTRIES",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_PRODUCT_COUNTRIES_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          productIdFromProductMaster: this.message.productIdFromProductMaster,
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
            this.labelCall();
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }


  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.grid[this.previousIdx].childCheckBox = false;
      }
      list.childCheckBox = true;
      this.auditTrail.refNo = list.RISK_SCALE_ID;
    } else {
      list.childCheckBox = false;
    }
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBox);
    this.previousIdx = idx;
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, productCountries: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : productCountries.PRODUCT_COUNTRY_ID;
    this.auditTrail.productId_Audit_Trail = this.message.productIdFromProductMaster;
    this.auditTrail.gridName = 'PRODUCT_COUNTRIES';
    this.auditTrail.report_And_Popup_Name = 'Product Countries Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(productCountries);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Product Master Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  labelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error
      }
    });
  }

  public focusEmpty(): void {
    console.log();
  }
}
